<!--
 * @Description:
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:25:12
-->
<template>
    <div class='integralDeduction'>
        <span>积分</span>
        <span>抵扣{{goodData.maxDeductionAmount}}元</span>
    </div>
</template>
<script>
export default {
    props: ['goodData'],
    data () {
        return {

        };
    },
    mounted () {

    },
    methods: {

    }
};
</script>
<style lang="scss" scoped>
.integralDeduction{
    background-image: linear-gradient(-90deg, #F4D1BB 0%, #F8D9C1 100%);
    float:left;
    border-radius: 9px;
    font-size: 12px;
    margin-top:2px;
    span:nth-child(1){
        background: #1C1615;
        border-radius: 9px;
        display: inline-block;
        color:#F9CCB2;
        padding:0 10px;
    }
    span:nth-child(2){
        padding-right:8px;
        color:#181010;
    }
}
</style>
